import { Switch as SwitchBase, type SwitchProps } from "@heroui/react";

import { useAudio } from "@/contexts/AudioContext";

export const Switch = ({
  onValueChange,
  silent,
  children,
  ...props
}: SwitchProps & { silent?: boolean }) => {
  const Audio = useAudio();

  return (
    <SwitchBase
      {...props}
      onValueChange={(v) => {
        onValueChange?.(v);
        if (v && !silent) {
          Audio.play("UI_CLICK");
        }
      }}
    >
      {children}
    </SwitchBase>
  );
};
